import { PayementModeType, ReceiptPaymentLabel } from "src/utils/constants/constant";
import { useEffect, useState } from "react";
import { currencyFormat, dateFormatYMD, toWords } from "src/utils/helperFunction";
import { FeeTypes } from "src/utils/constants/constant";
import { ReceiptLogo as TopBarLogo } from "./ReceiptLogo";
import { AuthorizedSignature } from "./AuthorizedSignature";
import { IStudentInvoice } from "src/services/feesDetails/fees.model";
import { IStudentList } from "src/services/student/student.model";

interface ExactReceiptProps {
  invoiceData: IStudentInvoice | null | undefined;
  admissionData: IStudentList | undefined;
  label: string;
}

const ExactReceiptWithComposition = ({ invoiceData, admissionData, label }: ExactReceiptProps) => {
  const [receiptType, setReceiptType] = useState<string>();
  const [isChequeType, setIsChequeType] = useState<boolean>(false);
  useEffect(() => {
    if (invoiceData?.payment_mode === PayementModeType.CASH) {
      setReceiptType(ReceiptPaymentLabel.CASH);
      setIsChequeType(false);
    } else if (
      invoiceData?.payment_mode === PayementModeType.CHEQUE ||
      invoiceData?.payment_mode === PayementModeType.DD ||
      invoiceData?.payment_mode === PayementModeType.NEFT_IMPS
    ) {
      setReceiptType(ReceiptPaymentLabel.CHEQUE);
      setIsChequeType(true);
    } else {
      setIsChequeType(false);
      setReceiptType(ReceiptPaymentLabel.ONLINE);
    }
  }, [invoiceData]);

  return (
    <>
      <table className="student-receipt-table">
        <tbody>
          <tr>
            <td>
              {/* <Temporary Code Comment> */}
              {/* <ReceiptLogo invoiceDate={invoiceData?.invoiceDate} /> */}
            </td>
          </tr>
        </tbody>
        <tbody className={"receipt-content-padding"}>
          <tr>
            <td>
              <table
                className={"gx-w-100" + (invoiceData?.branch?.registered_office_address ? "" : " receipt-border-bottom")}
              >
                <tbody
                  className={"gx-d-flex gx-align-items-center"}
                >
                  <TopBarLogo invoiceData={invoiceData} />
                  <tr className={"receipt-width-20 gx-text-center"}>
                    <td
                      className={"receipt-font-heading gx-d-inline-block receipt-font-bold receipt-title-padding-composition"}
                    >
                      Bill Of Supply
                    </td>
                  </tr>
                  <tr className={"receipt-width-40 gx-text-right"}>
                    <td
                      className={"receipt-font-large receipt-font-bold receipt-branch-title-spacing"}
                    >
                      {invoiceData?.branch_name !== null ? invoiceData?.branch_name : invoiceData?.branch?.title}
                    </td>
                    <td className={"receipt-font-body"}>
                      <b>Branch Address</b> :{" "}
                      {invoiceData?.address || invoiceData?.branch?.address || "-"}
                    </td>
                    <td>
                      Mobile No :&nbsp;
                      {invoiceData?.branch?.mobile_one ||
                        invoiceData?.branch?.landline_no}
                    </td>
                  </tr>
                </tbody>
              </table>
              {invoiceData?.branch?.registered_office_address ? (
                <table
                  className={"gx-w-100"}
                >
                  <tbody>
                    <tr>
                      <td
                        className={"receipt-border-bottom receipt-address-padding receipt-wrap-text receipt-break-word"}
                      >
                        <b>Registered Office Address</b> :{" "}
                        {invoiceData.branch.registered_office_address}
                      </td>
                    </tr>
                  </tbody>
                </table>
              ) : null}
              <table
                className={"gx-d-block receipt-section-padding"}
              >
                <tbody
                  className={"gx-d-flex gx-justify-content-between receipt-align-baseline"}
                >
                  <tr>
                    <td>
                      <b>Receipt No :</b>&nbsp; {invoiceData?.invoiceNo}
                    </td>
                    <td>
                      <b>Enrollment No :&nbsp;</b>{" "}
                      {invoiceData?.admission?.enrollment_number}
                    </td>
                    <td
                      className={"gx-text-capitalize"}
                    >
                      <b>Student Name :&nbsp;</b>
                      {invoiceData?.admission?.first_name +
                        " " +
                        invoiceData?.admission?.middle_name +
                        " " +
                        invoiceData?.admission?.last_name}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>GR Id :&nbsp;</b> {invoiceData?.admission?.gr_id}
                    </td>
                    <td>
                      <b>{label}&nbsp;Name</b> :&nbsp;
                      {admissionData && admissionData?.package?.name
                        ? admissionData?.package?.name
                        : admissionData?.admission_subcourses
                            ?.map((admissionSubcourse) => admissionSubcourse.subcourse?.name)
                            .join(", ")}
                    </td>
                  </tr>
                  <tr className={"gx-text-right"}>
                    <td className={"gx-text-nowrap"}>
                      <b>Date :&nbsp;</b>
                      {dateFormatYMD(invoiceData?.pay_date, "D MMM YY")}
                    </td>
                    <td className={"gx-text-nowrap"}>
                      <b>SAC :&nbsp;</b> 9992
                    </td>
                  </tr>
                </tbody>
              </table>

              <div>
                <table
                  className={"gx-w-100 receipt-border"}
                  border={0}
                  cellPadding={8}
                  cellSpacing={0}
                >
                  <thead>
                    <tr className={"gx-d-flex"}>
                      <th
                        className={"receipt-font-body receipt-border-right receipt-border-bottom gx-w-50 gx-text-center"}
                      >
                        Fees Type
                      </th>
                      <th
                        className={"receipt-font-body receipt-border-bottom gx-w-50 gx-text-center"}
                      >
                        Fees Paid
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      {invoiceData?.invoice_fees &&
                        invoiceData?.invoice_fees?.map((invoiceFee) => (
                          <>
                            {(Number(invoiceFee.amount) > 0 ||
                              invoiceFee.fee_type?.name === FeeTypes.TUITION) && (
                              <tr className={"gx-d-flex"}>
                                <td
                                  className={"receipt-font-body receipt-border-right receipt-border-bottom gx-w-50 gx-text-center"}
                                >
                                  {invoiceFee.fee_type?.name}
                                </td>
                                <td
                                  className={"receipt-font-body receipt-border-bottom gx-w-50 gx-text-center"}
                                >
                                  <span>&#8377;</span>
                                  {currencyFormat(
                                    Math.trunc(Number(invoiceFee.amount))
                                  )}
                                </td>
                              </tr>
                            )}
                          </>
                        ))}
                    </>
                  </tbody>
                  <tfoot>
                    <tr className={"gx-d-flex"}>
                      <td
                        className={"receipt-font-body receipt-border-right gx-w-50 gx-text-center receipt-font-bold"}
                      >
                        Total
                      </td>
                      <td
                        className={"receipt-font-body gx-w-50 gx-text-center"}
                      >
                        <span>&#8377;</span>
                        {currencyFormat(
                          Number(
                            invoiceData?.invoice_fees
                              ?.map((invoiceFee) => invoiceFee.amount)
                              ?.reduce((total, amount) => {
                                return Number(total) + Number(amount);
                              }, 0)
                          )
                        )}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <table
                className={"gx-w-100 receipt-auto-height receipt-section-padding gx-d-block"}
              >
                <thead
                  className={"gx-d-flex gx-justify-content-between"}
                >
                  <tr className={"gx-w-75"}>
                    {isChequeType === true ? (
                      <tr>
                        <td className={"receipt-font-body"}>
                          <b>Payment Mode :&nbsp;</b> {receiptType}
                          &nbsp;Payment
                        </td>
                        <td className={"receipt-font-body"}>
                          <b className="gx-mb-1 gx-d-inline-block">
                            Name :&nbsp;
                          </b>
                          {invoiceData?.cheque_holder_name}
                          <br />
                          <div className="gx-d-flex gx-mb-1">
                            <div>
                              <b>Cheque No</b> :&nbsp;
                              {invoiceData?.cheque_no},&nbsp;
                            </div>
                            <div className="gx-ml-2">
                              <b>Cheque Date</b>
                              :&nbsp;
                              {dateFormatYMD(invoiceData?.cheque_date, "DD-MM-YYYY")}
                            </div>
                          </div>
                          <b className="gx-mb-1 gx-d-inline-block">Bank Name</b>{" "}
                          :&nbsp;
                          {invoiceData?.bank_name}, (
                          {invoiceData?.bank_branch_name})
                        </td>
                      </tr>
                    ) : (
                      <tr className={"receipt-width-auto"}>
                        <td className={"receipt-font-body"}>
                          <b>Payment Mode :&nbsp;</b> {receiptType}
                          &nbsp;Payment
                        </td>
                      </tr>
                    )}
                    {invoiceData?.gst_no && (
                      <td
                        className={"gx-text-capitalize"}
                      >
                        <b>GSTIN</b> : {invoiceData?.gst_no}
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td
                      className={"receipt-font-body gx-text-right gx-text-capitalize"}
                    >
                      <b>The Sum of :&nbsp;</b>
                      <span className="gx-text-left">
                        {invoiceData?.invoice_fees &&
                          toWords.convert(
                            Number(
                              Number(
                                invoiceData?.invoice_fees
                                  ?.map((invoiceFee) => invoiceFee.amount)
                                  ?.reduce((total, amount) => {
                                    return Number(total) + Number(amount);
                                  }, 0)
                              )
                            )
                          )}
                      </span>
                    </td>
                  </tr>
                </thead>
              </table>
              <table
                className={"gx-w-100 gx-d-flex gx-align-items-end receipt-terms-padding"}
              >
                <tbody
                  className={"gx-w-75 receipt-line-readable receipt-word-spacing"}
                >
                  <tr>
                    <td className={"receipt-font-body"}>
                      <b>Terms & Conditions</b>
                    </td>
                    <td className={"receipt-font-body"}>
                      This invoice generated for educational services payment.
                    </td>
                    <td className={"receipt-font-body"}>
                      *Fees will be not refundable
                    </td>
                    <td className={"receipt-font-body"}>
                      <b>Note:</b>&nbsp;This&nbsp;is&nbsp;a&nbsp;digitally&nbsp;generated&nbsp;receipt.
                    </td>
                    {invoiceData?.admission_installments?.remarks ? (
                      <p>
                        <b>Remarks&nbsp;</b>:&nbsp;
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              invoiceData?.admission_installments?.remarks,
                          }}
                        />
                      </p>
                    ) : (
                      ""
                    )}
                  </tr>
                </tbody>
                <tbody className={"gx-w-25 gx-text-center"}>
                  <tr>
                    <td>
                      <AuthorizedSignature />
                    </td>
                    <td
                      className={"receipt-font-total receipt-line-compact gx-font-weight-medium"}
                    >
                      ------------------------
                    </td>
                    <td className={"receipt-font-body gx-font-weight-medium"}>
                      Authorized By
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default ExactReceiptWithComposition;
